import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule, MatSortModule, MatTableModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TranslateModule } from '@ngx-translate/core';
import { DragAndDropModule, DraggableHelper } from 'angular-draggable-droppable';
import { ClickOutsideModule } from 'ng-click-outside';
import { QuillModule } from 'ngx-quill';
import { RegisterFilterComponent } from 'src/app/pages/academic/attendance/register-filter/register-filter.component';
import {
  SendAbsentNotificationComponent,
} from 'src/app/pages/academic/attendance/register-old/send-absent-notification/send-absent-notification.component';
import { RegisterTebleComponent } from 'src/app/pages/academic/attendance/register/register-teble/register-teble.component';
import { RegisterComponent } from 'src/app/pages/academic/attendance/register/register.component';
import { QuestionFormComponent } from 'src/app/pages/academic/learning-path/question-form/question-form.component';
import {
  QuestionTypeCheckboxComponent,
} from 'src/app/pages/academic/learning-path/question-type-checkbox/question-type-checkbox.component';
import { QuestionTypeEssayComponent } from 'src/app/pages/academic/learning-path/question-type-essay/question-type-essay.component';
import {
  FillInBlankOptionDirective,
} from 'src/app/pages/academic/learning-path/question-type-fill-in-blank/fill-in-blank-option-directive.directive';
import {
  QuestionTypeFillInBlankComponent,
} from 'src/app/pages/academic/learning-path/question-type-fill-in-blank/question-type-fill-in-blank.component';
import {
  QuestionTypeMatchingComponent,
} from 'src/app/pages/academic/learning-path/question-type-matching/question-type-matching.component';
import {
  QuestionTypeMultipleChoiceComponent,
} from 'src/app/pages/academic/learning-path/question-type-multiple-choice/question-type-multiple-choice.component';
import {
  QuestionTypeTrueFalseComponent,
} from 'src/app/pages/academic/learning-path/question-type-true-false/question-type-true-false.component';
import {
  QuestionTypeUploadDocumentComponent,
} from 'src/app/pages/academic/learning-path/question-type-upload-document/question-type-upload-document.component';
import { NoteStudentGridComponent } from 'src/app/pages/academic/notes/add-note/note-student-grid/note-student-grid.component';
import {
  StudentNotesDetailsComponent,
} from 'src/app/pages/academic/notes/manage-notes/modal/student-notes-details/student-notes-details.component';
import {
  AssignTeachersManageComponent,
} from 'src/app/pages/academic/timetable/settings/assign-teachers/modals/assign-teachers-manage/assign-teachers-manage.component';
import { TimetablesComponent } from 'src/app/pages/classes/timetables/timetables.component';
import { GallerySettingsComponent } from 'src/app/pages/communications/gallery/gallery-settings/gallery-settings.component';
import { UserGridComponent } from 'src/app/pages/users/user-grid/user-grid.component';
import { UserActivitiesComponent } from 'src/app/pages/users/view-user/user-activities/user-activities.component';
import { UserHealthRecordsComponent } from 'src/app/pages/users/view-user/user-health-records/user-health-records.component';
import {
  ReportCardTemplateComponent,
} from 'src/app/pages/users/view-user/user-report-cards/report-card-template/report-card-template.component';
import { SubListMenuComponent } from 'src/app/templates/sub-list-menu/sub-list-menu.component';

import {
  IsEqualOrLessThanValidatorDirective,
  IsNumberValidator,
  MaxValidator,
  MinValidator,
  NoWhitespaceValidator,
} from '../../_validators';
import { DiscussionsComponent } from '../../pages/academic/learning-path//discussions/discussions.component';
import { PipesModule } from '../../pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { AcademicFilterComponent } from '../academic-filter/academic-filter.component';
import { AutoCompleteChipsComponent } from '../auto-complete-chips/auto-complete-chips.component';
import { AutoCompleteMultiComponent } from '../auto-complete-multi/auto-complete-multi.component';
import { BadgeComponent } from '../badge/badge.component';
import { BlankComponent } from '../blank/blank.component';
import { BodyComponent } from '../body/body.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { ChartBarComponent } from '../chartBar/chart-bar.component';
import { ChartLineComponent } from '../chartLine/chart-line.component';
import { ChartPieComponent } from '../chartPie/chart-pie.component';
import { CircularMenuComponent } from '../circularMenu/circular-menu.component';
import { ColoredOptionsComponent } from '../colored-options/colored-options.component';
import { CommunicationsPostComponent } from '../communications-post/communications-post.component';
import { FacebookDownloaderComponent } from '../communications-post/facebook-downloader/facebook-downloader.component';
import { FacebookUploaderComponent } from '../communications-post/facebook-uploader/facebook-uploader.component';
import { PostEditComponent } from '../communications-post/modal/post-edit/post-edit.component';
import { PostActionsComponent } from '../communications-post/post-actions/post-actions.component';
import { PostImageViewComponent } from '../communications-post/post-viewer/modal/post-image-view/post-image-view.component';
import {
  PostViewerLikeViewComponent,
} from '../communications-post/post-viewer/modal/post-viewer-like-view/post-viewer-like-view.component';
import { PostCommentsViewerComponent } from '../communications-post/post-viewer/post-comments-viewer/post-comments-viewer.component';
import { PostFilesViewerComponent } from '../communications-post/post-viewer/post-files-viewer/post-files-viewer.component';
import { PostImagesViewerComponent } from '../communications-post/post-viewer/post-images-viewer/post-images-viewer.component';
import { PostViewerComponent } from '../communications-post/post-viewer/post-viewer.component';
import { UrlThumbnailsComponent } from '../communications-post/url-thumbnails/url-thumbnails.component';
import { ConfirmMessageComponent } from '../confirm-message/confirm-message.component';
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { DeleteComponent } from '../delete/delete.component';
import { FullScreenComponent } from '../fullscreen/fullscreen.component';
import { MainFilterComponent } from '../main-filter/main-filter.component';
import { MessagesShaderComponent } from '../messages-shader/messages-shader.component';
import { NavigatorComponent } from '../navigator/navigator.component';
import { SliderSelectableComponent } from '../slider-selectable/slider-selectable.component';
import { SliderComponent } from '../slider/slider.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { TabnavbarComponent } from '../tab-nav-bar/tab-nav-bar.component';
import { UploadControlComponent } from '../uploadControl/upload-control/upload-control.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { WhatsappListComponent } from '../whatsapp-post/whatsapp-list/whatsapp-list.component';
import { WhatsappPostComponent } from '../whatsapp-post/whatsapp-post.component';
import { WhatsappCommentsComponent } from '../whatsapp-post/whatsapp-view/whatsapp-comments/whatsapp-comments.component';
import { WhatsappStudentInfoComponent } from '../whatsapp-post/whatsapp-view/whatsapp-student-info/whatsapp-student-info.component';
import { WhatsappViewComponent } from '../whatsapp-post/whatsapp-view/whatsapp-view.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forChild(),
    RouterModule,
    PipesModule,
    QuillModule,
    CKEditorModule,
    ClickOutsideModule,
    DragAndDropModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule
  ],
  exports: [
    IsNumberValidator,
    MinValidator,
    MaxValidator,
    NoWhitespaceValidator,
    IsEqualOrLessThanValidatorDirective,
    ReportCardTemplateComponent,
    UserActivitiesComponent,
    SharedModule,
    UserHealthRecordsComponent,
    RouterModule,
    TranslateModule,
    PipesModule,
    ClickOutsideModule,
    DragAndDropModule,
    UserMenuComponent,
    FullScreenComponent,
    BodyComponent,
    BreadcrumbComponent,
    BadgeComponent,
    TabnavbarComponent,
    UploadControlComponent,
    CircularMenuComponent,
    DatepickerComponent,
    ChartPieComponent,
    ChartBarComponent,
    ChartLineComponent,
    SliderComponent,
    AutoCompleteMultiComponent,
    AutoCompleteChipsComponent,
    SpinnerComponent,
    UserGridComponent,
    FillInBlankOptionDirective,
    TimetablesComponent,
    AcademicFilterComponent,
    DiscussionsComponent,
    SliderSelectableComponent,
    ColoredOptionsComponent,
    // the following Question Components used in lms and questions-bank
    QuestionFormComponent,
    QuestionTypeMultipleChoiceComponent,
    QuestionTypeCheckboxComponent,
    QuestionTypeTrueFalseComponent,
    QuestionTypeEssayComponent,
    QuestionTypeFillInBlankComponent,
    QuestionTypeMatchingComponent,
    QuestionTypeUploadDocumentComponent,
    SubListMenuComponent,
    GallerySettingsComponent,
    CommunicationsPostComponent,
    ConfirmMessageComponent,
    MessagesShaderComponent,
    WhatsappPostComponent,
    AssignTeachersManageComponent,
    RegisterComponent,
    FacebookUploaderComponent,
    FacebookDownloaderComponent,
    NoteStudentGridComponent,
    StudentNotesDetailsComponent,
    MainFilterComponent,
    NavigatorComponent
  ],
  declarations: [
    IsNumberValidator,
    MinValidator,
    MaxValidator,
    NoWhitespaceValidator,
    IsEqualOrLessThanValidatorDirective,
    ReportCardTemplateComponent,
    UserActivitiesComponent,
    DiscussionsComponent,
    FillInBlankOptionDirective,
    UserHealthRecordsComponent,
    BodyComponent,
    BlankComponent,
    UserMenuComponent,
    FullScreenComponent,
    BreadcrumbComponent,
    BadgeComponent,
    TabnavbarComponent,
    UploadControlComponent,
    CircularMenuComponent,
    DatepickerComponent,
    ChartPieComponent,
    ChartBarComponent,
    ChartLineComponent,
    SliderComponent,
    AutoCompleteMultiComponent,
    AutoCompleteChipsComponent,
    SpinnerComponent,
    UserGridComponent,
    TimetablesComponent,
    AcademicFilterComponent,
    SliderSelectableComponent,
    ColoredOptionsComponent,
    // the following Question Components used in lms and questions-bank
    QuestionFormComponent,
    QuestionTypeMultipleChoiceComponent,
    QuestionTypeCheckboxComponent,
    QuestionTypeTrueFalseComponent,
    QuestionTypeEssayComponent,
    QuestionTypeFillInBlankComponent,
    QuestionTypeMatchingComponent,
    QuestionTypeUploadDocumentComponent,
    SubListMenuComponent,
    DeleteComponent,
    GallerySettingsComponent,
    CommunicationsPostComponent,
    UrlThumbnailsComponent,
    FacebookUploaderComponent,
    PostViewerComponent,
    FacebookDownloaderComponent,
    PostViewerLikeViewComponent,
    PostCommentsViewerComponent,
    PostActionsComponent,
    PostEditComponent,
    ConfirmMessageComponent,
    MessagesShaderComponent,
    WhatsappPostComponent,
    WhatsappListComponent,
    WhatsappViewComponent,
    AssignTeachersManageComponent,
    RegisterComponent,
    RegisterFilterComponent,
    RegisterTebleComponent,
    SendAbsentNotificationComponent,
    WhatsappCommentsComponent,
    WhatsappStudentInfoComponent,
    PostImagesViewerComponent,
    PostFilesViewerComponent,
    PostImageViewComponent,
    NoteStudentGridComponent,
    StudentNotesDetailsComponent,
    MainFilterComponent,
    NavigatorComponent
  ],
  providers: [DraggableHelper],
  entryComponents: [
    DeleteComponent,
    PostViewerLikeViewComponent,
    PostEditComponent,
    ConfirmMessageComponent,
    AssignTeachersManageComponent,
    PostImageViewComponent,
    NoteStudentGridComponent,
    StudentNotesDetailsComponent
  ]
})
export class TemplatesModule {}
